import React, {Component} from 'react';
import SimplifiedCheckbox from '../../../utils/SimplifiedCheckbox';
import PropTypes from 'prop-types';

class GenericRow extends Component {
  constructor(props) {
    super(props);
  }

  getColumnStyle() {
    return {
      width: '100%',
      height: '21px',
      background: '#337AB71A',
      boxShadow: '0px 1px 4px 0px #00000040',
      font: 'helvetica',
      fontSize: '14px',
      textAlign: 'left',
      fontWeight: 'bold',
      display: 'block',
    };
  }

  getPermissionFromList(permissionName) {
    return this.props.permissionSection ? this.props.permissionSection.permissions.find((permission) => permission.name === permissionName) : {};
  }

  getEmptyDataContent() {
    return (
      <div className={'col-md-2'}>
        <div style={{backgroundColor: '#337AB71A', padding: '10px 0px 10px 0px', margin: '5px'}}>
          <input
            type="checkbox"
            style={{visibility: 'hidden', display: 'block', margin: 'auto'}}
          />
        </div>
      </div>
    );
  }

  getTableDataContent(permissionName) {
    const permission = this.getPermissionFromList(permissionName);
    return (
      <SimplifiedCheckbox
        fieldId={permission.name}
        value={permission.allowed}
        onChange={() => this.props.onChange(permission)}
      />
    );
  }
}

GenericRow.propTypes = {
  permissionSection: PropTypes.object,
  onChange: PropTypes.func,
};

export default GenericRow;
